import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';
import Button from '../reusable/Button';

const StyledDiv = styled.div`
  width: 100%;
  height: 189px;
  border-radius: 6px;
  background-repeat: no-repeat;
  background-image: ${({ img }) => `url(${img})`};
  background-size: 100% 100%;
  position: relative;
  display: block;
  @media only screen and (max-width: 568px) {
    height: 140px;
  }
`;

const StyledTitle = styled.p`
  color: #ffffff;
  margin-bottom: 16px;
  @media only screen and (max-width: 568px) {
    margin: 4px 0 8px 0;
  }
`;

const ResourcesCard = ({ brandTitle, img, href }) => (
  <>
    <FlexContainer justifyContent="space-between" margin="0 0 32px 0" mobileFlexDirection="column">
      <FlexItem width="60%" mobileWidth="100%">
        <StyledDiv img={img} />
      </FlexItem>
      <FlexContainer flexDirection="column" width="34%" mobileWidth="100%" justifyContent="flex-end">
        <StyledTitle className="xlarge bold">{brandTitle}</StyledTitle>
        <a href={href} target="_blank" rel="noreferrer noopener">
          <Button width="175px" fontWeight={1}>
            Download
          </Button>
        </a>
      </FlexContainer>
    </FlexContainer>
  </>
);

ResourcesCard.propTypes = {
  brandTitle: PropTypes.string.isRequired,
  img: PropTypes.objectOf(PropTypes.any).isRequired,
  href: PropTypes.string.isRequired,
};
export default ResourcesCard;
